import { Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const BioMetricLock = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('account');
  const HandleNavigation = () => {
    navigate('/bio-metric/info');
    // console.log('clicked');
  };
  return (
    <div className="h-[100svh]">
      <div className="border-b-1 border border-x-0 border-t-0 border-solid border-[#0000001F] bg-white p-2">
        <Typography fontSize={20} fontWeight={600} color="primary.500">
          {t('enableDisable')}
        </Typography>
      </div>

      <div className="mt-24">
        <Typography
          variant="subtitle1"
          fontWeight={500}
          color="secondary.100"
          fontSize={16}
          className="text-center"
        >
          {t('processingBiometricLock')}
        </Typography>
        <div className="mt-3 text-center">
          <Button
            className="items-center justify-center px-2 py-1 text-center"
            onClick={HandleNavigation}
          >
            {t('bioMetricLock')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BioMetricLock;
